import { render, staticRenderFns } from "./CartItemRow.vue?vue&type=template&id=a6a94286&"
import script from "./CartItemRow.vue?vue&type=script&lang=ts&"
export * from "./CartItemRow.vue?vue&type=script&lang=ts&"
import style0 from "./CartItemRow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wannes.vermeulen/Repositories/dorst-app/dorst/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a94286')) {
      api.createRecord('a6a94286', component.options)
    } else {
      api.reload('a6a94286', component.options)
    }
    module.hot.accept("./CartItemRow.vue?vue&type=template&id=a6a94286&", function () {
      api.rerender('a6a94286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/CartItemRow.vue"
export default component.exports